var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7444 40.7647H53.8792C53.8792 34.9069 49.3504 29.5763 43.7185 29.5763C41.3379 29.5763 39.1316 30.455 37.3898 31.978C39.7122 34.2039 41.2799 37.25 41.7444 40.7647Z",
    fill: "#A8ADB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7125 29.0392C46.6946 29.0392 49.1122 26.6001 49.1122 23.5914C49.1122 20.5827 46.6946 18.1437 43.7125 18.1437C40.7303 18.1437 38.3127 20.5827 38.3127 23.5914C38.3127 26.6001 40.7303 29.0392 43.7125 29.0392Z",
    fill: "#A8ADB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5475 32.5191C20.8057 30.9375 18.5993 29.9417 16.1608 29.9417C10.5869 29.9417 6 35.3308 6 41.1886H18.1348C18.5993 37.7325 20.2251 34.745 22.5475 32.5191Z",
    fill: "#A8ADB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1612 29.5327C19.1434 29.5327 21.5609 27.0936 21.5609 24.0849C21.5609 21.0762 19.1434 18.6372 16.1612 18.6372C13.179 18.6372 10.7615 21.0762 10.7615 24.0849C10.7615 27.0936 13.179 29.5327 16.1612 29.5327Z",
    fill: "#A8ADB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1638 44.2975V44.8718H16.738H42.2851H42.8594V44.2975C42.8594 36.1904 36.9106 29.4888 29.5116 29.4888C22.1126 29.4888 16.1638 36.1904 16.1638 44.2975Z",
    fill: "#A8ADB2",
    stroke: "white",
    strokeWidth: 1.14853
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5718 29.2419C33.3235 29.2419 36.365 26.1734 36.365 22.3883C36.365 18.6031 33.3235 15.5347 29.5718 15.5347C25.82 15.5347 22.7786 18.6031 22.7786 22.3883C22.7786 26.1734 25.82 29.2419 29.5718 29.2419Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/guests.84ebafb658b5f9443693039598cb0ff3.svg";
export { ForwardRef as ReactComponent };